import { useTranslation } from 'react-i18next';
import { HELP_CENTER } from '@/consts/links';
import { classicUrl } from '@/utils/classicLinks';

export const useAssistNavigationItems = () => {
  const { t } = useTranslation(['navigation']);

  return [
    {
      id: 'go-to-assist',
      label: t('crossPlatform.secondary.helpCenter'),
      route: HELP_CENTER,
      target: '_blank' as const,
    },
    {
      id: 'technical-glossary',
      label: t('crossPlatform.secondary.technicalGlossary'),
      route: classicUrl('help/sbdata-glossary'),
    },
  ];
};
